var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4f4f8;}.cls-2{fill:#e5e5e5;}.cls-3{fill:#bbb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 15.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16,.25A15.75,15.75,0,1,1,.25,16,15.77,15.77,0,0,1,16,.25M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17,20.25l-1-3.17-1,3.17H11.62l2.71,2-1,3.18,2.7-2,2.7,2-1-3.18,2.71-2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "15.33 16.45 15.33 8.72 11.46 8.72 11.46 14.59 15.33 16.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "20.54 14.59 20.54 8.72 16.67 8.72 16.67 16.45 20.54 14.59"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverMedal);
export default __webpack_public_path__ + "static/media/silverMedal.a870bad2cf9dfc1492513fec33913d0d.svg";
export { ForwardRef as ReactComponent };